/* =========================================================================
   Peek + nudge — horizontal product strips.
   The "peek" (a sliver of the next card) is handled in CSS. This adds the
   "nudge": the first time a scrollable strip enters the viewport, gently
   scroll it a touch and back so the motion signals that it swipes.

   Contract: mark the scrolling row with [data-peek-nudge].
   Runs once per row, only when scrollable, and never after the user has
   already interacted or when reduced motion is requested.
   ========================================================================= */
(function () {
  // Included by several sections; only wire up global listeners once.
  if (window.__peekNudgeLoaded) return;
  window.__peekNudgeLoaded = true;

  var NUDGE_PX = 32;
  var MOBILE = '(max-width: 749px)';

  function prefersReducedMotion() {
    return (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function isMobile() {
    return window.matchMedia && window.matchMedia(MOBILE).matches;
  }

  function nudge(row) {
    var max = row.scrollWidth - row.clientWidth;
    if (max < 10) return; // nothing hidden → no hint needed

    var distance = Math.min(NUDGE_PX, max);
    // scroll-snap: mandatory would fight the partial nudge — pause it.
    var prevSnap = row.style.scrollSnapType;
    row.style.scrollSnapType = 'none';

    row.scrollTo({ left: distance, behavior: 'smooth' });
    window.setTimeout(function () {
      row.scrollTo({ left: 0, behavior: 'smooth' });
      window.setTimeout(function () {
        row.style.scrollSnapType = prevSnap;
      }, 500);
    }, 600);
  }

  function init(row) {
    if (row.__peekNudgeInit) return;
    row.__peekNudgeInit = true;

    // If the visitor engages before the hint fires, skip it entirely.
    var done = false;
    function markDone() {
      done = true;
    }
    row.addEventListener('touchstart', markDone, { passive: true, once: true });
    row.addEventListener('wheel', markDone, { passive: true, once: true });
    row.addEventListener('pointerdown', markDone, { passive: true, once: true });

    if (prefersReducedMotion() || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.disconnect();
          // Mobile-only affordance — desktop already reveals a partial card.
          if (!done && isMobile()) nudge(row);
        });
      },
      { threshold: 0.6 }
    );
    observer.observe(row);
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(
      scope.querySelectorAll('[data-peek-nudge]'),
      init
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
